import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  setFlightsTypeFilter,
  selectFlightsType,
} from "_redux/slices/timeline/timeline-data";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import {
  selectSelectedTimeline,
} from "_redux/slices/timeline/timeline-areas";
// tremor
import { Block, Flex, Text, Metric } from "@tremor/react";
// constants 
import { SaudiDomesticAirports } from "_utils/timeline-constants";
// select
import Select from "react-select";

const flightsTypeOptions = [
  { label: "All", value: "all" },
  { label: "International", value: "international" },
  { label: "Domestic", value: "domestic" }
]
const JobTypeDropdown = () => {
  // redux
  const dispatch = useDispatch();
  const flightsType = useSelector(selectFlightsType); // select flightsType (international,domestic,all)
  const dbUser = useSelector(selectFirebaseInfo); // logged in user
  const selectedTimeline = useSelector(selectSelectedTimeline);

  // states
  const [showDropDown, setShowDropDown] = useState(false)    // holds the value to show the dropdown or not 

  useEffect(() => {
    // check if the logged user authority is not Saudi airport ignore the flight type filter and the dropdown
    if (!SaudiDomesticAirports.includes(dbUser.details.authority)) {
      dispatch(setFlightsTypeFilter("all"));
      setShowDropDown(false)
    }
    // check if the logged user authority is Saudi airport and if a timeline is not selected 
    if (SaudiDomesticAirports.includes(dbUser.details.authority) && Object.isObjectEmpty(selectedTimeline)) {
      dispatch(setFlightsTypeFilter("all"));
      setShowDropDown(true)
    }
    // check if the logged user authority is Saudi airport and if a timeline is selected 
    if (SaudiDomesticAirports.includes(dbUser.details.authority) && !Object.isObjectEmpty(selectedTimeline)) {
      // check if timeline is international
      if (selectedTimeline?.international && !selectedTimeline?.domestic) {
        dispatch(setFlightsTypeFilter("international"))
        setShowDropDown(false)
      };
      // check if timeline is domestic
      if (!selectedTimeline?.international && selectedTimeline?.domestic) {
        dispatch(setFlightsTypeFilter("domestic"));
        setShowDropDown(false)
      }
      // check if timeline is both domestic and international
      if (selectedTimeline?.international && selectedTimeline?.domestic) {
        dispatch(setFlightsTypeFilter("all"))
        setShowDropDown(true)
      };
    }

  }, [selectedTimeline]);

  const createFlightsTypeFilterValue = () => {
    let appliedFilter = flightsTypeOptions.filter((type) => flightsType === type?.value);
    return Array.isFullArray(appliedFilter) ? appliedFilter : []
  };

  return (
    <div >
      {showDropDown &&
        <Col style={{ maxWidth: 300, minWidth: 150, marginInlineStart: 13 }}>
          <Select
            options={flightsTypeOptions}
            placeholder="Displayed bookings..."
            onChange={(selection) => dispatch(setFlightsTypeFilter(selection?.value ?? "all"))}
            value={createFlightsTypeFilterValue()}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 4,
              })
            }}
          />
        </Col>
      }
    </div>
  );
};

export default JobTypeDropdown;
